import { Component } from '@angular/core';

@Component({
  selector: 'lib-help-icon',
  standalone: true,
  imports: [],
  templateUrl: './help-icon.component.html',
})
export class HelpIconComponent {}
